import React, { Component } from 'react';
import store from '@/store/index';
import { Flex, List, InputItem, Button, Checkbox, Toast, Modal } from 'antd-mobile';
import DPassword from './components/password';
import { 
  getLocation, getQueryVariable,
  AppList, getArray2Name, asyncLoadJs, $t,
  onWrapTouchStart,
  sensorsMonitor,
  changeIco,
  getWhiteTime,
  getProxyConfig,
  setAliasApp,
} from '@/utils/utils';
import { ApiGetSmsCode, ApiGetCaptcha, ApiRegister, ApiCheckMobileRegister } from '@/api/index';
const AgreeItem = Checkbox.AgreeItem;
const SaSdk = sensorsMonitor();
let BranchJs;
class Register extends Component {
  constructor(props) {
    super(props);
    // 当前app，用该参数来区分对应app 借以区分不同的ip地址 默认都是印度
    const localApp = setAliasApp(props.match.params.app || 'rsrush');
    let app = getArray2Name(AppList, localApp);

    if (!app) {
      app = AppList[0]; // 默认走印度
    }
    // 设置多语言key
    store.dispatch({ type: 'set-i18n', data: app.i18n || 'en_US' })

    this.state = {
      localApp,
      appRules: app, // 当前app相关配置
      modalShow: false,
      latitude: '',
      longitude: '',
      showCaptcha: false,
      canSendVerification: true,
      sendTextTimeStart: false,
      firstSendVerification: true, // 记录下是否是第一次点击发送
      sendVerificationTime: 60,
      graphicCode: '',
      canLoadCode: true,
      deviceMid: SaSdk.store.getDistinctId(),
      canSendRegister: true,
      canSetProfile: true,
      notOperated: true, // 默认都是未操作
      firstMap: {
        password: false,
        rePassword: false,
      }, // 第一次操作 默认都没有操作
      // 输入框相关 默认全都有错
      mobile: {
        value: '',
        hasError: true,
        errorMsg: $t('plzPhone'),
      },
      captcha: {
        value: '',
        hasError: true,
        errorMsg: $t('plzGraphicVerification'),
      }, // 图形验证码
      smsCode: {
        value: '',
        hasError: true,
        errorMsg: $t('plzSms'),
      }, //验证码
      password: {
        value: '',
        hasError: true,
        errorMsg: $t('plzPwd'),
      },
      rePassword: {
        value: '',
        hasError: true,
        errorMsg: $t('plzComPwd'),
      },
      inviteCode: {
        value: '',
        hasError: false,
        errorMsg: '',
      }, // 邀请码
      canEditInviteCode: false,
      agree: {
        value: true,
        hasError: false,
        errorMsg: $t('plzGgree'),
      },
    }
  };
  
  // 号码变化
  mobileChange = (val) => {
    let _v = val.replace(/\s/g, '');
    let { regexp } = this.state.appRules;

    let set = {};
    if (!_v.length) {
      set = {
        hasError: true,
        errorMsg: $t('plzPhone'),
      }
    } else if( !regexp.test(_v) ) {
      // (localApp === 'kashway' || localApp === 'ipesa') && !/^[7|1]\d{8}$/.test(_v)
      // (localApp.includes('rsrush') && !/^[6-9]\d{9}$/.test(_v)
      set = {
        hasError: true,
        errorMsg: $t('wrongPhone'),
      }
    } else {
      set = {
        hasError: false,
        errorMsg: '',
      };
      setTimeout(()=>{
        this.onReloadGraphicCode();
      }, 0)
    }
    
    set.value = val; // 号码格式化

    this.formBlur('mobile');
    this.setState({
      mobile: Object.assign(this.state.mobile, set),
    });
  }
  formatPhone(val) {
    let t = val +'';
    // 印度号码 仅10位
    if (t.length <= 3) {
      return t;
    } else if(t.length <= 7) {
      return t.substring(0, 3) + ' ' + t.substring(3, 7);
    }
    return t.substring(0, 3) + ' ' + t.substring(3, 7) + ' ' + t.substring(7, 10);
  }
  // 验证码相关
  captchaChange = (val) => {
    let _v = val.replace(/\s/g, '');
    let set = {};
    if (!_v.length) {
      set = {
        hasError: true,
        errorMsg: $t('plzGraphicVerification'),
      }
    } else {
      set = { hasError: false, errorMsg: '', };
    }
    set.value = val;
    this.formBlur('captcha');
    this.setState({
      captcha: Object.assign(this.state.captcha, set),
    });
  }
  // 短信验证码变化 
  // TODO 后期看看可有优化部分代码
  smsCodeChange = (val) => {
    let _v = val.replace(/\s/g, '');
    let set = {};
    if (!_v.length) {
      set = {
        hasError: true,
        errorMsg: $t('plzSms'),
      }
    } else if(_v.length > 4) {
      set = {
        hasError: true,
        errorMsg: $t('more4'),
      }
    } else {
      set = { hasError: false, errorMsg: '', };
    }
    set.value = val;
    this.formBlur('smsCode');
    this.setState({
      smsCode: Object.assign(this.state.smsCode, set),
    });
  }
  passwordChange = (val, key) => {
    this.formBlur(key);

    if (key === 'password') {
      setTimeout(() => {
        this.repwdRef.checkVal();
      }, 80)
      this.setState({
        password: Object.assign(this.state.password, val),
      });
    } else {
      this.setState({
        rePassword: Object.assign(this.state.rePassword, val),
      });
    }
  }
  agreeChange = (e) => {
    let _v = e.target.checked;
    let set = {};
    if (_v) {
      set = { hasError: false, errorMsg: '', };
      
    } else {
      set = {
        hasError: true,
        errorMsg: $t('plzGgree'),
      }
    }
    set.value = _v;
    this.formBlur('agree');
    this.setState({
      agree: Object.assign(this.state.agree, set),
    });
  }
  // 获取确认密码ref
  onRepwdRef = (ref) => {
    this.repwdRef = ref;
  }

  // 所有输入框相关数据
  getSendData() {
    let d = this.state;
    let res = {
      country: d.appRules.areaCode,
      latitude: d.latitude,
      longitude: d.longitude,
      channel: 'h5',
    };
    const InputArray = ['mobile', 'captcha', 'smsCode', 'password', 'rePassword', 'inviteCode', 'agree'];
    for(let key in d) {
      if (InputArray.includes(key)) {
        let v = d[key].value;
        if (typeof v === 'string') {
          res[key] = v.replace(/\s/g, '');
        } else {
          res[key] = v;
        }
      }
    }
    return res;
  }

  // 图像验证码相关
  onReloadGraphicCode = ()=>{
    if( !this.state.canLoadCode ) return;
    this.setState({ canLoadCode: false })

    const { appRules } = this.state;
    const { header } = appRules;
    ApiGetCaptcha({
      data: JSON.stringify({ 
        "mobile": this.getSendData().mobile || "1",
        "scenes":"register",
        ...this.getVestParams(),
      }),
      responseType: "arraybuffer",
      headers: header,
      ...getProxyConfig(this.state.localApp),
    }).then(res=>{
      let blob = new Blob([res], { type: "image/png" });

      this.setState({
        graphicCode: (window.URL || window.webkitURL).createObjectURL(blob),
        canLoadCode: true,
      })
    }).catch(err=>{
      this.setState({
        graphicCode: '',
      })

      setTimeout(() => { // 延迟3s防止有人刷链接
        this.setState({
          canLoadCode: true
        })
      }, 3000)
    })
  }

  setMonitorData = (key, data)=> {
    // 神策上传
    SaSdk.track(key, {
      ...data
    });

    // Branch上传
    if (BranchJs) {
      BranchJs.logEvent(
        key,
        data,
      )
    }
  }

  setVerificationTimeVal() {
    this.setState({
      sendVerificationTime: this.state.sendVerificationTime - 1
    })
    if( this.state.sendVerificationTime <= 0 ) {
      this.setState({
        sendTextTimeStart: false,
        canSendVerification: true,
        sendVerificationTime: 60,
      });
      clearInterval(this.intervalTimer);
    }
  }
  onSendCodeClick = (e)=>{
    const evt = e || window.event;
    evt.preventDefault();

    this.setMonitorData('h5_clicksend');
    this.formBlur('mobile');
    this.formBlur('captcha');
    if( this.state.mobile.hasError || this.state.captcha.hasError ) {
      return;
    }

    if( !this.state.canSendVerification ) {
      Toast.fail($t('smsNoClick'), 2);
      return;
    }
    // this.sendVerificationProxy();
    this.checkMobileIsReg();
  }

  checkMobileIsReg () {
    // 目前仅针对乌干达做注册前号码校验
    if (this.state.localApp === 'ucredit') {
      const { header } = this.state.appRules;
      const send = this.getSendData();
      ApiCheckMobileRegister({
        ...getProxyConfig(this.state.localApp),
        headers: header,
        data: {
          mobile: send.mobile,
          ...this.getVestParams(),
        }
      }).then(() => {
        this.sendVerificationProxy()
      }).catch(err => {
        this.setState({
          smsCode: Object.assign(this.state.smsCode, {
            hasError: true,
            errorMsg: err.msg,
          }),
        });
        this.formBlur('smsCode');
      })
    } else {
      this.sendVerificationProxy()
    }
  }

  sendVerificationProxy() {
    this.setState({ canSendVerification: false });

    let send = this.getSendData();
    const { header } = this.state.appRules;

    ApiGetSmsCode({
      headers: header,
      data: {
        country: send.country,
        mobile: send.mobile,
        deviceId: this.state.deviceMid,
        captcha: send.captcha,
        "scenes": "register",
        ...this.getVestParams(),
      },
      ...getProxyConfig(this.state.localApp),
    }).then( ()=>{
      this.setState({ sendTextTimeStart: true, firstSendVerification: false });
      this.intervalTimer = setInterval(()=>{
        this.setVerificationTimeVal();
      }, 1000);
      Toast.success($t('smsSendSuccess'), 2);
    })
    .catch(err=>{
      if (err.code === '10003') {
        this.onReloadGraphicCode();
      }
      this.setMonitorData('h5_otperror')
    }).finally(()=>{
      this.setState({ canSendVerification: true });
    })
  }

  // 发送字符串的变化 需添加对应的倒计时
  sendVerificationText() {
    let { 
      sendTextTimeStart, 
      canSendVerification, 
      sendVerificationTime, 
      firstSendVerification } = this.state;
    if (!sendTextTimeStart) {
      return canSendVerification ? (firstSendVerification ? $t('send') : $t('resend')) : $t('sending');
    }
    
    return (<span className='btn-disable'>{ sendVerificationTime }</span>);
  }

  // 是否显示验证码 需要等待手机号码输入结构校验
  showCaptchaBox() {
    // 已经进行操作 & 没有错误
    if (this.state.firstMap['mobile'] && !this.state.mobile.hasError) {
      return (
        <List renderHeader={() => $t('graphicCode') }>
          <InputItem
            error={this.state.captcha.hasError}
            onChange={this.captchaChange}
            onBlur={()=> this.formBlur('captcha')}
            value={this.state.captcha.value}
            extra={<span className='suffix_graphic-code'>
              <img 
                alt='Mib'
                src={ this.state.graphicCode }
                onClick={ this.onReloadGraphicCode } />
            </span>}
          >
          </InputItem>
          { this.showErrorMsg('captcha') }
        </List>
      )
    }
    return '';
  }
  // 是否显示对应错误信息 输入对应state里的key值
  showErrorMsg(key = 'mobile') {
    let d = this.state[key];
    if (this.state.firstMap[key] && d.hasError) {
      return <span className='hasError-box'>{ d.errorMsg }</span>;
    }
    return '';
  }
  formBlur = (key) => {
    let o = {};
    o[key] = true;
    this.setState({
      firstMap: Object.assign(this.state.firstMap, o),
    })
  }

  checkFiled () {
    const check = ['mobile', 'captcha', 'smsCode', 'password', 
      'rePassword', 'inviteCode', 'agree'];
    let res = {};
    let data = this.state;
    check.forEach(_ => {
      res[_] = true;
    })
    this.setState({
      firstMap: Object.assign(data.firstMap, res),
    })

    for(let i in data) {
      if (check.includes(i)) {// 还有错误就返回false 标识校验不通过
        if( data[i].hasError ) return false;
      }
    }
    return true;
  }

  onFinish = () => {
    this.setMonitorData('h5_register_click');
    if (this.checkFiled()) {
      this.registerProxy();
    }
  }

  registerProxy() {
    if( !this.state.canSendRegister ) return;
    this.setState({ canSendRegister: false });

    const sendData = this.getSendData();
    const { header } = this.state.appRules;

    this.setMonitorData('register');
    ApiRegister({
      data: {
        ...sendData,
        ...this.getVestParams(),
      },
      headers: header,
      ...getProxyConfig(this.state.localApp),
    }).then(res=>{
      Toast.success($t('registerSuccess'));
      SaSdk.login(res.customerId || '');
      this.setMonitorData('h5_registercomplete');
      this.setMonitorData('register', {
        is_success: true,
        register_type: 'h5',
        invitation_code: sendData.inviteCode
      });

      this.registerSuccess();
    }).catch((err)=>{
      this.setMonitorData('register', {
        is_success: false,
        register_type: 'h5',
        invitation_code: sendData.inviteCode,
        message: err.msg || err.message
      });

      if (err.code === '3006') {
        this.setMonitorData('h5_otpwrong')
      }
      this.setMonitorData('h5_registerfail');
    }).finally(()=>{
      this.setState({ canSendRegister: true })
    })
  }

  registerSuccess() {
    this.setState({ modalShow: true });
  }
  onModalClose () {
    this.setState({ modalShow: false });
  }
  onDownLoad () {
    this.setMonitorData('h5_download_click');
    window.open(this.state.appRules.download, 'target');
    this.setState({ modalShow: false });
  }

  initLocation() { // 获取经纬度
    let _location = getLocation();
    _location.then(data=>{
      this.setState({
        latitude: data.latitude,
        longitude: data.longitude,
      })
    })
  }
  /**
   * 获取默认邀请码
   * 有邀请码则不可修改 无邀请码则认为是用户自定义输入
   */
  getInviteCode() {
    let iv = getQueryVariable('inviteCode');
    console.log(iv)
    let hasCode = iv && iv.length;

    if (hasCode) {
      iv = iv.replace(/\s/g, '');
      this.setState({
        inviteCode: Object.assign(this.state.inviteCode, {value: iv}),
      })
    }

    this.setState({
      canEditInviteCode: !hasCode,
    })
  }
  inviteCodeChange = (val) => {
    let { canEditInviteCode } = this.state;
    if (canEditInviteCode) {
      this.formBlur('inviteCode');
      let setObj = {};
      let cleanVal = val.replace(/\s/g, '');
      if (cleanVal.length && !/^[A-Za-z0-9]+$/.test(cleanVal)) {
        setObj = {
          hasError: true,
          errorMsg: $t('wrongInvite'),
        }
      } else {
        setObj = {
          hasError: false,
          errorMsg: '',
        }
      }
      setObj.value = val;
      this.setState({
        inviteCode: Object.assign(this.state.inviteCode, setObj),
      })
    }
  }
  // 数据打点相关
  sensorsInit() {
    SaSdk.registerPage({
      current_url: window.location.href,
      pagename: 'h5_register',
      appName: this.state.appRules.appName,
    })

    SaSdk.quick('autoTrack');
    SaSdk.track('h5_register_pageview', {
      load_time: getWhiteTime()
    });
  }

  initBranch() {
    const { appRules } = this.state;
    const Deeplink = window.location.href;
    // load branch
    asyncLoadJs('https://cdn.branch.io/branch-latest.min.js').then(()=>{
      BranchJs = window.branch;
      // init branch
      BranchJs.init(appRules.branchKey, { metadata: Deeplink });
      // 记录pv
      BranchJs.deepview({
        'channel': 'mobile_web',
        'feature': 'deepview',
        data: {
          'custom_bool': true,
          'custom_int': Date.now(),
          'deeplink': Deeplink,
          '$deeplink_path': Deeplink,
        }
      })
    }).catch(err => {
      console.log('has error', err);
    })
  }
  // 获取马甲包对应添加参数
  getVestParams() {
    const { appRules } = this.state;
    if (appRules.params) return appRules.params;
    return null;
  }

  renderPwd () {
    // const { localApp } = this.state;
    // if (localApp === 'champloan') {
    //   return '';
    // }

    return <List>
      <DPassword
        label={ $t('plzSetPwd') }
        rePassword={false}
        passwordVal={this.state.password.value}
        first={this.state.firstMap.password}
        onChange={(val) => this.passwordChange(val, 'password')}
        onFocus={()=> this.setMonitorData('h5_enterpassword1') }
      />
      <DPassword
        label={ $t('comPwd') }
        triggerRef={ this.bindRef }
        rePassword={true}
        first={this.state.firstMap.rePassword}
        passwordVal={this.state.password.value}
        onChange={(val) => this.passwordChange(val, 'rePassword')}
        onRef={ (ref) => this.onRepwdRef(ref) }
        onFocus={()=> this.setMonitorData('h5_enterpassword2') }
      />
    </List>
  }

  initPwd () {
    const { localApp } = this.state;
    if (localApp === 'champloan') {
      this.setState({
        password: Object.assign(this.state.password, {
          hasError: false,
        }),
        rePassword: Object.assign(this.state.rePassword, {
          hasError: false,
        }),
        agree: Object.assign(this.state.agree, {
          value: false,
          hasError: true,
        }),
      })
    }
  }

  componentDidMount() {
    document.title = $t('registerNow');
    changeIco(this.state.localApp);

    this.getInviteCode();
    this.initLocation();
    this.sensorsInit();
    this.initBranch();
    this.initPwd(); // champion无需密码 无需校验
  }
  componentWillUnmount() {
    clearInterval(this.intervalTimer);
  }

  render() {
    let mobileError = this.showErrorMsg('mobile');
    let smsError = this.showErrorMsg('smsCode');
    let inviteError = this.showErrorMsg('inviteCode');
    let agreeError = this.showErrorMsg('agree');
    let CaptchaBox = this.showCaptchaBox();
    let sendText = this.sendVerificationText();
    const pwdBox = this.renderPwd();

    let { localApp } = this.state;
    // console.log(localApp)
    // 默认是印度kashway 切换app可变化为对应app

    // const appClass = localApp.replaceAll('.', '-');
    let mainClassName = 'content-box register '+ localApp;
    let modalClassName = 'register-modal ' + localApp;
    let { phonePlaceholder, phoneLength, areaCode, termsOfUse, privacyPolicy } = this.state.appRules;
    const urlRoot = window.$localCdnLink + '/app/' + localApp + '/register/';

    return <Flex direction='column' className={mainClassName}>
      <Modal
        className={modalClassName}
        visible={this.state.modalShow}
        closable={true}
        transparent
        maskClosable={false}
        onClose={()=> this.onModalClose() }
        title={ $t('registerSuccess') }
        footer={[{ text: $t('downloadNow'), onPress: () => { this.onDownLoad() } }]}
        wrapProps={{ onTouchStart: onWrapTouchStart }}
        afterClose={() => {  }}
      >
        <h2>{ $t('registerSuccess') }</h2>
        <p dangerouslySetInnerHTML={{ __html: $t('needDownload') }}></p>
      </Modal>

      <Flex.Item className='register-header'>
        <img
          src={ `${ urlRoot }invite.webp` }
          alt="MIB"
        />
      </Flex.Item>
      <Flex.Item className='register-main'>
        <List renderHeader={() => $t('mobile') }>
          <InputItem
            type="phone"
            maxLength={phoneLength}
            placeholder={phonePlaceholder}
            error={this.state.mobile.hasError}
            onChange={ this.mobileChange }
            onBlur={()=> this.formBlur('mobile')}
            value={this.state.mobile.value}
            onFocus={()=> this.setMonitorData('h5_enterphone1')}
          >
            <div className='register-main_mobile'>
              <div className='mobile-flag'></div>
              <span>+{ areaCode }</span>
            </div>
          </InputItem>
          { mobileError }
        </List>

        { CaptchaBox }

        <List renderHeader={() => $t('plzVerification') }>
          <InputItem
            type="number"
            maxLength={4}
            error={this.state.smsCode.hasError}
            onChange={this.smsCodeChange}
            onBlur={()=> this.formBlur('smsCode')}
            value={this.state.smsCode.value}
            extra={
              <span
                className='input-extra__btn'
                onClick={(e) => this.onSendCodeClick(e) }
              >
                { sendText }
              </span>
            }
          >
          </InputItem>
          { smsError }
        </List>

        { pwdBox }

        <List renderHeader={() => $t('inviteCode') }>
          <InputItem
            type="text"
            error={this.state.inviteCode.hasError}
            onChange={this.inviteCodeChange}
            onBlur={()=> this.formBlur('inviteCode')}
            editable={this.state.canEditInviteCode}
            value={this.state.inviteCode.value}
          >
          </InputItem>
          { inviteError }
        </List>

        <List className='border-none'>
          <AgreeItem
            error={this.state.agree.hasError}
            onChange={this.agreeChange}
            checked={this.state.agree.value}
          >
            <span className='ant-checkbox-label'>
              <span>{ $t('accept') }</span>
              <a href={ termsOfUse } target='_blank' rel="noopener noreferrer">{ $t('termsOfUse') }</a>
              <span>{ $t('and') }</span>
              <a href={ privacyPolicy } target='_blank' rel="noopener noreferrer">{ $t('privacyPolicy') }</a>
            </span>
          </AgreeItem>
          { agreeError }
        </List>

        <List className='border-none'>
          <Button type="primary"
            className='submie-btn'
            disabled={!this.state.canSendRegister}
            onClick={(e)=> this.onFinish(e)}
          >
            { $t('registerNow') }
          </Button>
        </List>
      </Flex.Item>
    </Flex>
  }
}

export default Register;
